import { Likes } from "../entities/userMatch";
import { LikesParams } from "../entities/getLikesParams";
import { MatchRepository } from "../repositories/MatchRepository";

export class GetMyLikes {
	constructor(private repository: MatchRepository) {}
	execute(params: GetMyLikesParams): Promise<Likes[]> {
		return this.repository.getMyLikes(params.params);
	}
}

export class GetMyLikesParams {
	constructor(public params: LikesParams) {}
}
